import React from "react";
import "./WorkHistoryTab.scss";

const work = [
  {
    role: "Frontend Engineer",
    start: "Dec/21",
    end: "April/22",
    company: "CryptoOwl",
    description: [
      "Developed and deployed 3 crypto websites using ReactJS",
      "Created monitoring tools through dashboard for an important cryptocurrency coin (Capped at $2Mil)",
      "Integrated Web3 Metamask wallet for smoother crypto payments through wallets",
      "Handled integration of various Web3 elements for purpose of Treasury and Staking managementDeveloped",
    ],
  },
  {
    role: "Software Engineer",
    start: "Aug/22",
    end: "Oct/22",
    company: "Applied AI Consultancy",
    description: [
      "Developed and tested UI components for an AI based lead generation software",
    ],
  },
  {
    role: "Frontend Engineer",
    start: "Oct/21",
    end: "Dec/22",
    company: "RawConscious",
    description: [
      "Contributed to CMS based Sass product",
      "Contributed in the design and development of an e-commerce website",
    ],
  },
];
const WorkHistoryTab = () => {
  return (
    <div className="workhistoryWrapper">
      {work.map((item, id) => {
        return (
          <div className="work" key={id}>
            <div className="timeline">
              <div className="srNumber">{work.indexOf(item)}</div>

              <div className="link"></div>
            </div>

            <div className="workDetails">
              <div className="workrole">
                <span>{item.role}</span>,&nbsp;{item.company}
              </div>

              <div className="workduration">
                {item.start} - {item.end}
              </div>

              <div className="workdescription">
                <ul>
                  {item.description.map((des, id) => {
                    return <li key={id}>{des}</li>;
                  })}
                </ul>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default WorkHistoryTab;
